import React, { Component } from "react";

import { addNewFile } from "../../utils/file-utils";
import greenCheck from "../../images/green-check.svg";
import recycleBin from "../../images/icon-trash.svg";

export class FileComponent extends Component {
  render() {
    return (
      <div>
        <p>Attach supporting document</p>
        <div>
          <div style={{ display: "none" }}>
            <input
              type="file"
              name="file"
              id="file"
              ref={(input) => (this.fileinput = input)}
              onChange={(e) =>
                addNewFile(e.target.files[0], this.props.addNewFileCallback)
              }
            />
          </div>
          <div>
            {this.props.file && (
              <table className="upladed-file">
                <tr>
                  <td className="file-uploaded-image">
                    <img alt="uploaded file" src={greenCheck} />
                  </td>
                  <td>{this.props.file.Name}</td>
                  <td>
                    <img
                      alt="remove file"
                      onClick={(e) => {
                        this.props.deleteFile();
                        this.fileinput.value = "";
                        e.preventDefault();
                      }}
                      className="delete-file-button"
                      src={recycleBin}
                    />
                  </td>
                </tr>
              </table>
            )}
            <button
              className="quote-change-file"
              onClick={(e) => {
                this.fileinput.click();
                e.preventDefault();
              }}
            >
              Select a File
            </button>
          </div>
        </div>
      </div>
    );
  }
}
